import { useQuery } from "@tanstack/react-query";
import RestAPI from "../../../util/RestAPI";
import { Promotion } from "../types";

export const usePromotion = () => {
  const query = useQuery({
    queryKey: ["promotion"],
    queryFn: async () => {
      return await RestAPI.get("/promotions").then(async (res) => {
        return (await res.json()) as any as Promotion;
      });
    },
  });

  return query;
};
